import { render, staticRenderFns } from "./Formulario006.vue?vue&type=template&id=990d708e&scoped=true"
import script from "./Formulario006.vue?vue&type=script&lang=js"
export * from "./Formulario006.vue?vue&type=script&lang=js"
import style0 from "./Formulario006.vue?vue&type=style&index=0&id=990d708e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990d708e",
  null
  
)

export default component.exports